import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { DisplayText, TextContainer } from './../../components'
import { renderActions } from './../../utils/actions'

import styles from './EmptyState.scss'

export default class EmptyState extends PureComponent {
  render() {
    const { children, heading, image, actions } = this.props

    return (
      <div className={styles.EmptyState}>
        <div className={styles.Section}>
          <div className={styles.DetailsContainer}>
            <TextContainer className={styles.Details}>
              <DisplayText size="extraSmall">{heading}</DisplayText>
              <div className={styles.Content}>{children}</div>
              <div className={styles.Actions}>{renderActions(actions)}</div>
            </TextContainer>
          </div>
          {image && (
            <div className={styles.ImageContainer}>
              <img alt="" className={styles.Image} src={image} />
            </div>
          )}
        </div>
      </div>
    )
  }
}

EmptyState.propTypes = {
  title: PropTypes.string,
  image: PropTypes.string,
  heading: PropTypes.string,
  actions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
}



// WEBPACK FOOTER //
// ./src/components/EmptyState/index.js